var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "bar-wrapper"
  }, [_c("a-row", {
    staticClass: "bar-list",
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: "游戏时长统计图",
      hoverable: true,
      bordered: false
    }
  }, [_c("gradients-bar", {
    staticClass: "chart-bar"
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: "运动类目统计图",
      hoverable: true,
      bordered: false
    }
  }, [_c("more-bar", {
    staticClass: "chart-bar"
  })], 1)], 1)], 1), _c("div", {
    staticClass: "bar-list"
  }, [_c("a-card", {
    attrs: {
      title: "用户年龄段统计图",
      hoverable: true,
      bordered: false
    }
  }, [_c("double-bar", {
    staticClass: "chart-bar white"
  })], 1)], 1), _c("a-row", {
    staticClass: "bar-list",
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: "游戏热度统计图",
      hoverable: true,
      bordered: false
    }
  }, [_c("group-bar", {
    staticClass: "chart-bar"
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: "运动得分",
      hoverable: true,
      bordered: false
    }
  }, [_c("pie-bar", {
    staticClass: "chart-bar"
  })], 1)], 1)], 1), _c("a-row", {
    staticClass: "bar-list",
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: "条形占比",
      hoverable: true,
      bordered: false
    }
  }, [_c("proportion-bar", {
    staticClass: "chart-bar"
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };